import { z } from "zod";
import { AlgorithmOperation } from "@algoquest/schemas";

/**
 * `attempt-events` domain DTOs (Master Spec §19/§28/§33, Phase 10).
 * Deliberately a separate endpoint from `attempts` (matching §33's own
 * separate `attempts`/`attempt-events` domain names) rather than nesting
 * the trace inside `SubmitAttemptRequestSchema`: the summary metrics
 * (comparisons/mistakes/etc.) are small and always sent together, while
 * a full operation trace can be large and — per §19 — may be drained
 * from the IndexedDB outbox in more than one batch. Splitting them lets
 * a client sync "the attempt happened" before "the full replay trace,"
 * which matters if a connection drops mid-sync.
 */
export const SubmitAttemptEventsRequestSchema = z.object({
  attemptId: z.string().uuid(),
  operations: z.array(AlgorithmOperation).min(1),
});
export type SubmitAttemptEventsRequest = z.infer<typeof SubmitAttemptEventsRequestSchema>;

/**
 * `accepted` counts only rows actually inserted this call — a replayed
 * batch whose events were already synced returns a lower (possibly zero)
 * count via the same `onConflictDoNothing` idempotency
 * `attempt_events_attempt_sequence_unique` gives at the database layer,
 * without that being treated as an error.
 */
export const SubmitAttemptEventsResponseSchema = z.object({
  accepted: z.number().int().nonnegative(),
});
export type SubmitAttemptEventsResponse = z.infer<typeof SubmitAttemptEventsResponseSchema>;
